export default "__VITE_ASSET__CmS_Ks6n__";